export default __webpack_public_path__ + "static/media/app-ride.030ae092.png";